import React from 'react'
import { MenuList } from 'vnetwork-ui'

interface MenuListSkeletonProps {
    numberOfItems?: number
    customMenuItemStyle?: string
}

const MenuListSkeleton: React.FC<MenuListSkeletonProps> = ({
    numberOfItems = 3,
    customMenuItemStyle = 'hover:bg-secondary-20 text-sm gap-3',
}) => {
    const skeletonMenuItems = [...Array(numberOfItems)].map((_) => ({
        children: (
            <div className="flex items-center gap-3 animate-pulse w-[100px]">
                <div className="size-5 bg-gray-200"></div>
                <div className="flex-1 h-5 bg-gray-200"></div>
            </div>
        ),
        className: `${customMenuItemStyle} pointer-events-none`,
        onClick: () => {},
    }))

    return (
        <MenuList
            menuitems={skeletonMenuItems}
            onSelect={() => {}}
            size="medium"
        />
    )
}

export default MenuListSkeleton
